import React from "react";
import { Consumer as WorkflowConsumer } from "./context";
import { Helmet } from "react-helmet-async";

const WorkflowPageTitle = () => (
  <WorkflowConsumer>
    {({ title, getActiveStep }) => {
      const activeStep = getActiveStep();
      if (!activeStep || !title) return null;
      return (
        <Helmet>
          <title>{title + " | " + activeStep.label}</title>
        </Helmet>
      );
    }}
  </WorkflowConsumer>
);

export default WorkflowPageTitle;
